<div class="nav">
  @for (link of links(); track link.route) {
    <a class="nav__item" [class.disabled]="link.disabled" [routerLink]="link.route" routerLinkActive="nav__item_active">
      <mat-icon [className]="'nav__icon ' + link.classIcon" [svgIcon]="link.icon!"></mat-icon>
      <span class="body-6 nav__name">{{ pageKey() + link.name | translate }}</span>
    </a>
  }
</div>
